import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from "react-bootstrap/Button";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';
import momentPlugin from '@fullcalendar/moment';

import './Calendar.scss' // webpack must be configured to do this
import classes from './Calendar.css';
import Container from 'react-bootstrap/Container';

import CalendarSelection from '../UI/CalendarSelection/CalendarSelection';

class Calendar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {selectedEvent: null, selectedEventElement: null}
        this.handleDateClick = this.handleDateClick.bind(this);
        this.bookButtonRef = React.createRef()
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    getEvents() {
        let isMobile = this.props.isMobile;
        let events = this.props.availabilities.map(function(timestamp)
            {   
                // for smaller screen
                if (isMobile===true) {
                    return {
                        start: new Date(timestamp*1000),
                        title: "30 mins",
                    }
                } 
                
                // for larger screen
                else {
                    return {
                        start: new Date(timestamp*1000),
                    }
                }
            });
        return events;
    }

    getMinDate() {
        let minEvent;
        if (this.props.availabilities.length > 0){
            minEvent = Math.min(...this.props.availabilities) * 1000;
        }
        else {
            minEvent = Date.now();
        }
        return minEvent;
    }

    getMaxDate() {
        let maxEvent;
        if (this.props.availabilities.length > 0){
            maxEvent = Math.max(...this.props.availabilities) * 1000;
        }
        else {
            maxEvent = Date.now();
        }
        return maxEvent + 300000*1000;
    }


    handleDateClick = (arg) => {
        if (this.state.selectedEventElement){
            let currentEventElement = this.state.selectedEventElement;
            currentEventElement.style.backgroundColor = "white";
            currentEventElement.style.color = "black";
        }
        this.setState({selectedEvent: arg.event, selectedEventElement: arg.el});
        arg.el.style.backgroundColor = "var(--color-main)";
        arg.el.style.color = "white";

        this.props.pickCallback(this.state.selectedEvent.start.getTime()/1000);

        // scroll to the book button
        // this is temporary disabled to provide a better user experience
        // this.bookButtonRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }

    handleBook = () => {
        if ((this.state.selectedEvent !== null) && (this.state.selectedEventElement !== null)){
            this.props.selectCallback(this.state.selectedEvent.start.getTime()/1000);
        }
    }

    render() {

        let headerSettingAdaptive;
        let defaultViewAdaptive;
        let pluginAdaptive;

        let displaySize = "none";

        // Adaptive Setting Based on Screen Size
        if (this.props.isMobile===true){
            headerSettingAdaptive = {
                left: 'title',
                center: '',
                right: 'prev,next'
            };
            defaultViewAdaptive = "listWeek";
            pluginAdaptive = listPlugin;
            displaySize = 'none';
        }
        else {
            headerSettingAdaptive = {
                left: 'title',
                center: '',
                right: 'today prev,next'
            };
            defaultViewAdaptive = "dayGridMonth";
            pluginAdaptive = dayGridPlugin;
        }

        let calendarNote = null;
        if (this.props.calendarNote) {
            calendarNote = (
                <Row>
                    <Col>
                        <div className={classes.CalendarNote}>
                        <b><p>Calendar Note</p></b>
                        {this.props.calendarNote}
                        </div>
                    </Col>
                </Row>
            )
        }

        return (
            <Container>
                { calendarNote }
                <Row>
                    <Col>
                    <b>Please select a time below</b>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className={classes.Calendar}>
                            <FullCalendar
                            eventLimit={4}
                            header={headerSettingAdaptive}
                            titleFormat={{
                                year: 'numeric', 
                                month: 'short'
                            }}
                            validRange={{
                                start: this.getMinDate(),
                                end: this.getMaxDate(),
                            }}
                            height="parent"
                            contentHeight="auto"
                            eventTextColor="black"
                            eventBackgroundColor="white"
                            eventBorderColor="var(--color-main)"
                            defaultView={ defaultViewAdaptive }
                            eventTimeFormat={{
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            }}
                            eventClick={this.handleDateClick}
                            plugins={ [pluginAdaptive, momentPlugin] }
                            fixedWeekCount={false}
                            events={ this.getEvents() }
                            defaultTimedEventDuration="0:30"
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CalendarSelection calendarOwnerFirstName={this.props.calendarOwnerFirstName} calendarBookingSelectedAvailability={this.props.selectedAvailability}></CalendarSelection>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className={classes.Book} ref={this.bookButtonRef}>
                            <Button variant="info" size={displaySize} onClick={this.handleBook}> Book </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default Calendar;


// WEBPACK FOOTER //
// ./src/containers/Schedule/Calendar/Calendar.js